// Forgot password page JavaScript
console.log('Forgot password page loaded')
